module.exports = __webpack_public_path__ + "img/savings-icon.332b397d.svg";